// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  z-index: 1;
  padding-right: 0.5rem;
  min-width: 7rem;
  height: 2.5rem;
  border-radius: 2rem;
  background: var(--color-light-blue);
}
.info .flex-container {
  display: flex;
  flex-direction: row;
  height: 100%;
}
.info .icon-default {
  width: 1.2rem;
}
.info .icon-open {
  width: 2.2rem;
}
.info .text {
  font-size: 1rem;
  color: var(--color-primary-blue);
  font-weight: bold;
  line-height: 1.375rem;
}
.info .flex-col {
  display: flex;
  align-items: center;
}
.info .flex-col.flex-col-last {
  flex-grow: 1;
  padding-right: 0.5rem;
}
.info .book {
  padding: 0 0.6rem;
  background: white;
  cursor: pointer;
  border-radius: 4rem;
  min-width: 2rem;
}
.info .book.open {
  border-radius: 2rem 0 0 2rem;
  min-width: 2rem;
}
.info .flag-col {
  min-width: 2rem;
}
.info .flag-col.flag-solo {
  padding: 0 0.8rem;
}
.info .flag {
  height: 1rem;
  width: 1rem;
  box-shadow: 0 0.083rem 0 0 rgba(0, 0, 0, 0.24);
  border-radius: 50%;
}
.info .oval {
  position: absolute;
  bottom: -1.15rem;
  left: -0.8rem;
  z-index: 15;
  cursor: pointer;
}
.info .oval img {
  width: 4rem;
  height: 4rem;
}
.info .check-here {
  position: absolute;
  bottom: 4rem;
  left: -7rem;
  padding: 1rem;
}
.info .check-here .text {
  color: white;
  width: 10.708rem;
  font-size: 0.833rem;
  line-height: 1rem;
  text-align: center;
  font-weight: normal;
}
.info .check-here .white-arrow .white-arrow-icon {
  position: absolute;
  right: 7.5rem;
  width: 2rem;
  height: 3.333rem;
  --animate-duration: 1s;
}`, "",{"version":3,"sources":["webpack://./src/app/components/book-button/book-button.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,mCAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AACJ;AAEE;EACE,aAAA;AAAJ;AAGE;EACE,aAAA;AADJ;AAIE;EACE,eAAA;EACA,gCAAA;EACA,iBAAA;EACA,qBAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;AAHJ;AAKI;EACE,YAAA;EACA,qBAAA;AAHN;AAOE;EACE,iBAAA;EACA,iBAAA;EACA,eAAA;EAEA,mBAAA;EACA,eAAA;AANJ;AAQI;EACE,4BAAA;EACA,eAAA;AANN;AAUE;EACE,eAAA;AARJ;AAUI;EACE,iBAAA;AARN;AAYE;EACE,YAAA;EACA,WAAA;EACA,8CAAA;EACA,kBAAA;AAVJ;AAaE;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AAXJ;AAYI;EACE,WAAA;EACA,YAAA;AAVN;AAcE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AAZJ;AAcI;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAZN;AAiBM;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AAfR","sourcesContent":[".info {\n  position: absolute;\n  bottom: 1rem;\n  right: 1rem;\n  z-index: 1;\n  padding-right: 0.5rem;\n  min-width: 7rem;\n  height: 2.5rem;\n  border-radius: 2rem;\n  background: var(--color-light-blue);\n\n  .flex-container {\n    display: flex;\n    flex-direction: row;\n    height: 100%;\n  }\n\n  .icon-default {\n    width: 1.2rem;\n  }\n\n  .icon-open {\n    width: 2.2rem;\n  }\n\n  .text {\n    font-size: 1rem;\n    color: var(--color-primary-blue);\n    font-weight: bold;\n    line-height: 1.375rem;\n  }\n\n  .flex-col {\n    display: flex;\n    align-items: center;\n\n    &.flex-col-last {\n      flex-grow: 1;\n      padding-right: 0.5rem;\n    }\n  }\n\n  .book {\n    padding: 0 0.6rem;\n    background: white;\n    cursor: pointer;\n\n    border-radius: 4rem;\n    min-width: 2rem;\n\n    &.open {\n      border-radius: 2rem 0 0 2rem;\n      min-width: 2rem;\n    }\n  }\n\n  .flag-col {\n    min-width: 2rem;\n\n    &.flag-solo {\n      padding: 0 0.8rem;\n    }\n  }\n\n  .flag {\n    height: 1rem;\n    width: 1rem;\n    box-shadow: 0 0.083rem 0 0 rgba(0, 0, 0, 0.24);\n    border-radius: 50%;\n  }\n\n  .oval {\n    position: absolute;\n    bottom: -1.15rem;\n    left: -0.8rem;\n    z-index: 15;\n    cursor: pointer;\n    img {\n      width: 4rem;\n      height: 4rem;\n    }\n  }\n\n  .check-here {\n    position: absolute;\n    bottom: 4rem;\n    left: -7rem;\n    padding: 1rem;\n  \n    .text {\n      color: white;\n      width: 10.708rem;\n      font-size: 0.833rem;\n      line-height: 1rem;\n      text-align: center;\n      font-weight: normal;\n    }\n  \n    .white-arrow {\n  \n      .white-arrow-icon {\n        position: absolute;\n        right: 7.5rem;\n        width: 2rem;\n        height: 3.333rem;\n        --animate-duration: 1s;\n      }\n  \n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
